'use client'
import * as React from 'react'
import { trackGalleryView } from '@/lib/analytics/ga4'

// Fires a single gallery_view GA4 event when a gallery surface mounts. Drop into
// a server component (e.g. the industry gallery page) to record the impression
// without making the whole page client-rendered.
export function GalleryViewBeacon({ gallery, surface }: { gallery?: string; surface: string }) {
  const sent = React.useRef(false)
  React.useEffect(() => {
    if (sent.current) return
    sent.current = true
    trackGalleryView({ surface, gallery })
  }, [surface, gallery])
  return null
}
